export default {
    public: {
        ENVIRONMENT: 'stage',
        API_URL: 'https://api-cf-stage.codepresso.io',
        CODE_RUN_BRIDGE_API_URL: 'https://coderun-bridge-stage.codepresso.io',
        CODE_RUN_BRIDGE_SOCKET_URL: 'wss://coderun-bridge-stage.codepresso.io/global',
        SOCIAL_REDIRECT_URL: 'https://codepresso.io/auth/user/social',

        CODERUN_DOMAIN: 'https://coderun-stage.codepresso.io',

        MIXPANEL_TOKEN: "c20f725df035b82e467f791eeade1695",

        AWS_IDENTITY_POLL_ID: "ap-northeast-2:216a7f2c-317e-440e-bd65-785475927845",
        LEARNING_DEFAULT_DIRECTORY_BUCKET: "codepresso-global-contents-multi-file",
        LEARNING_DEFAULT_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://contents-multifile-stage.codepresso.io",
        LEARNING_USER_DIRECTORY_BUCKET: "codepresso-global-user-multi-file",
        USER_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://user-file.codepresso.io",
        LEARNING_USER_ANALYSIS_DIRECTORY_BUCKET: "codepresso-global-analysis-report-stage",
        LEARNING_USER_ANALYSIS_DIRECTORY_BUCKET_CLOUDFRONT_DOMAIN: "https://static-analysis-reports-stage.codepresso.io",

        COOKIE_DOMAIN: 'codepresso.io',
        // onboarding/survey SDK·자산을 로드할 S3 prefix 도메인 (s3://codepresso-onboarding/{값}/). stage 는 live 자산 재사용 가정(별도 stage prefix 미배포). 배포되면 갱신.
        SDK_ASSET_DOMAIN: 'contents-stage.codepresso.io',
        MAIN_URL: 'https://contents-stage.codepresso.io/',
        BUILD_VERSION: 'v2.18.0',
        BUILD_COMMIT: 'unknown',
        BUILD_TIME: '',
        DESKTOP_APP_NAME: 'Proctive',
        DESKTOP_APP_VERSION: '1.8.0',
        PRODUCT_FRUITS_WORKSPACE_CODE: '0gIxreipuStmDVcj',
        ADAPTIVE_LECTURE_URL: 'https://dev-adaptive-lecture.codepresso.io/track-level',

        STRIPE_PUBLISHABLE_KEY: 'pk_test_51QweExQG9d1TvnQPi3QANFrRlluXXYxYVeoISEEGO2GoCbIEMRVAmVyAIWeiWjXYQ8KrWAITLWkza4EXXPEzB0Dj00Yo2sJ0FQ',
        TOSS_CLIENT_KEY: 'test_ck_6BYq7GWPVvNo669JKv4mVNE5vbo1',
        TOSS_PAYMENT_CLIENT_KEY: 'test_ck_5OWRapdA8dmEKm9MvXb63o1zEqZK',
    }
};
